const scrolled_into_view_class = 'scrolled-into-view',
    min_percentage_viewable = 20

module.exports = {
    init() {
        this.listener()
        this.actionElements()
    },
    listener() {
        document.addEventListener(
            'scroll',
            () => {
                this.actionElements()
            }
        )
    },
    actionElements() {
        for (const element of document.getElementsByClassName(scrolled_into_view_class)) {

            const visible_height_px = element.getBoundingClientRect().top - window.innerHeight;

            //if visible and the visible px amount is a greater or equal percentage of total height as min_percentage_viewable, add class specified by data attribute
            (visible_height_px < 0)
            && (
                (100 * Math.abs(visible_height_px)) / element.clientHeight
            ) >= min_percentage_viewable
            && element.classList.add(
                element.dataset.viewableClass
            )
        }
    }
}
